module.exports = __webpack_public_path__ + "static/media/jamjam4x.63ba63e9.png";